import CustomAdvanceTable from 'components/common/advance-table/CustomAdvanceTable';
import Avatar from 'components/common/Avatar';
import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import SoftBadge from 'components/common/SoftBadge';
import TableRowAction from 'components/common/TableRowAction';
import DonorSponsorshipModal from 'components/donar-details/modals/DonorSponsorshipModal';
import SelectBeneficiaryModal from 'components/donar-details/modals/SelectBeneficiaryModal';
import DonorCounter from 'components/donar/DonarCounter';
import {
  weBeneficiariesItems,
  weDonarTableData,
  weUserImage2
} from 'data/weraise-data/donar-data';
import React, { useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';

const AllBeneficiaries = () => {
  const [modalShow, setModalShow] = useState(false);
  const [beneficiaryModalShow, setBeneficiaryModalShow] = useState(false);
  const columns = [
    {
      accessor: 'id',
      Header: 'ID',
      cellProps: {
        className: 'py-2 fw-medium '
      }
    },
    {
      accessor: 'name',
      Header: 'Name',
      cellProps: {
        className: 'py-2 fw-medium '
      },
      Cell: rowData => {
        const { name } = rowData.row.original;
        return (
          <Flex alignItems="center">
            <Avatar src={weUserImage2} rounded="circle" size="xl" />
            <Button
              variant="link"
              onClick={() => setModalShow(true)}
              className="fw-medium ms-2 fs--1 p-0 text-1100 hover-primary"
            >
              {name}
            </Button>
          </Flex>
        );
      }
    },
    {
      accessor: 'age',
      Header: 'Age',
      cellProps: {
        className: 'py-2 fw-medium '
      }
    },
    {
      accessor: 'location',
      Header: 'Location',
      cellProps: {
        className: 'py-2 fw-medium '
      }
    },
    {
      accessor: 'gender',
      Header: 'Gender',
      cellProps: {
        className: 'py-2 fw-medium '
      }
    },
    {
      accessor: 'sponsor',
      Header: 'Sponsor',
      cellProps: {
        className: 'fw-medium text-800 py-2'
      }
    },
    {
      accessor: 'sp_validity',
      Header: 'Sp. Until',
      cellProps: {
        className: 'fw-medium py-2'
      },
      Cell: rowData => {
        const { sp_validity } = rowData.row.original;
        return sp_validity ? sp_validity : <>&mdash;</>;
      }
    },

    {
      accessor: 'priority',
      Header: 'Priority',
      cellProps: {
        className: 'fw-medium  py-2'
      },
      Cell: rowData => {
        const { priority } = rowData.row.original;
        return priority ? (
          <SoftBadge pill bg={rowData.row.original.variant} className="me-2">
            {priority}
          </SoftBadge>
        ) : (
          <>&mdash;</>
        );
      }
    },
    {
      accessor: 'type',
      Header: 'Type',
      cellProps: {
        className: 'fw-medium text-800 py-2'
      }
    },
    {
      accessor: 'id_d',
      Header: '',
      headerProps: {
        className: 'text-end'
      },
      cellProps: {
        className: 'text-end fw-medium py-2'
      },
      disableSortBy: true,
      Cell: rowData => {
        const { id } = rowData.row;
        return (
          <TableRowAction
            onCLickEdit={() => console.log(id)}
            onCLickDelete={() => console.log(id)}
          />
        );
      }
    }
  ];

  const content = (
    <>
      <IconButton
        variant="primary"
        size="sm"
        icon="link"
        transform="shrink-3"
        className="me-2"
        onClick={() => setBeneficiaryModalShow(true)}
      >
        <span className="ms-1 d-none d-lg-inline-block">Sponsor</span>
      </IconButton>
      <IconButton
        variant="falcon-default"
        size="sm"
        icon="child"
        transform="shrink-3"
        className="me-2"
        onClick={() => {}}
      >
        <span className="ms-1 d-none d-lg-inline-block">Add Beneficiary</span>
      </IconButton>
    </>
  );

  return (
    <>
      <Row>
        <Col>
          <DonorCounter counterData={weBeneficiariesItems} />
        </Col>
      </Row>
      <Row>
        <Col md={12} xxl={12} className="h-md-100">
          <CustomAdvanceTable
            data={weDonarTableData}
            columns={columns}
            title={`Beneficiaries (${weDonarTableData?.length})`}
            addNew={false}
            content={content}
            showSearchInput
            searchInputPlaceHolder="Search users"
            showTablePagination
            perPage={10}
          />
        </Col>
      </Row>

      <DonorSponsorshipModal
        setModalShow={setModalShow}
        modalShow={modalShow}
      />

      <SelectBeneficiaryModal
        modalShow={beneficiaryModalShow}
        setModalShow={setBeneficiaryModalShow}
        path="/donors/1289/sponsor"
      />
    </>
  );
};

export default AllBeneficiaries;
